var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldDotted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 270,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#shield-dotted_svg__clip0_518_3654)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "shield-dotted_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -172,
    y: -25,
    width: 477,
    height: 478
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.392,
    strokeDasharray: "1.39 6.96",
    d: "M-171.186 1.152h475.98M-171.186 9.502h475.98M-171.186 17.853h475.98M-171.186 26.203h475.98M-171.186 34.554h475.98M-171.186 42.904h475.98M-171.186 51.255h475.98M-171.186 59.605h475.98M-171.186 67.956h475.98M-171.186 76.307h475.98M-171.186 84.657h475.98M-171.186 93.008h475.98M-171.186 101.358h475.98M-171.186 109.709h475.98M-171.186 118.059h475.98M-171.186 126.41h475.98M-171.186 134.761h475.98M-171.186 143.111h475.98M-171.186 151.462h475.98M-171.186 159.812h475.98M-171.186 168.163h475.98M-171.186 176.513h475.98M-171.186 184.864h475.98M-171.186 193.214h475.98M-171.186 201.565h475.98M-171.186 209.916h475.98M-171.186 218.266h475.98M-171.186 226.617h475.98M-171.186 234.967h475.98M-171.186 243.318h475.98M-171.186 251.669l475.98-.001M-171.186 260.019h475.98M-171.186 268.369h475.98"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#shield-dotted_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.739 31.2H52.203A16.754 16.754 0 0035.45 47.955v61.538c0 93.841 79.391 124.961 95.286 130.238a16.162 16.162 0 0010.471 0c15.916-5.287 95.286-36.407 95.286-130.248V47.954a16.753 16.753 0 00-16.754-16.753zm-38.742 91.548l-31.738 12.691 18.544 24.764a8.38 8.38 0 01-1.675 11.728 8.38 8.38 0 01-11.728-1.676l-18.429-24.575-18.429 24.575a8.376 8.376 0 11-13.403-10.052l18.576-24.764-31.769-12.691a8.388 8.388 0 01-.139-15.502 8.386 8.386 0 016.422-.057l30.365 12.156V89.838a8.377 8.377 0 0116.754 0v29.507l30.366-12.156a8.38 8.38 0 016.421.057 8.397 8.397 0 014.5 4.581 8.382 8.382 0 01-.057 6.422 8.393 8.393 0 01-4.581 4.499z",
    fill: "#FDFCF7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "shield-dotted_svg__clip0_518_3654"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h270v270H0z"
  })))));
}
export default SvgShieldDotted;